export default function Machines_B_9 (number = 1) {
  return {
    name: '微型粒子对撞机',
    icon: '/static/img/machines/b9.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_9.js